<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Token" class="d-icon d-icon--token" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.251.701a1.5 1.5 0 0 1 1.498 0h.001l3.5 2A1.5 1.5 0 0 1 11 4v4a1.503 1.503 0 0 1-.75 1.299l-.002.001-3.498 1.999h-.001a1.5 1.5 0 0 1-1.498 0H5.25l-3.498-2-.002-.001A1.5 1.5 0 0 1 1 8V4a1.502 1.502 0 0 1 .75-1.298l.002-.001 3.5-2Zm.749.8a.5.5 0 0 0-.25.067l-.002.001L2.25 3.568A.503.503 0 0 0 2 4v4a.5.5 0 0 0 .25.431s-.001 0 0 0l3.5 2a.5.5 0 0 0 .5 0h.002l3.498-2s0 .001 0 0A.503.503 0 0 0 10 8V4a.5.5 0 0 0-.25-.432c.001 0 0 0 0 0l-3.5-2A.5.5 0 0 0 6 1.501Z" fill="currentColor"/><path d="M7 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconToken',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
